export default __webpack_public_path__ + "static/media/Polityka_Prywatności_Shake_Tips.715b08e5.pdf";